import { render } from "./WalletSelectModal.vue?vue&type=template&id=00c84602&scoped=true&ts=true"
import script from "./WalletSelectModal.vue?vue&type=script&lang=ts"
export * from "./WalletSelectModal.vue?vue&type=script&lang=ts"

import "./WalletSelectModal.vue?vue&type=style&index=0&id=00c84602&scoped=true&lang=css"
import "./WalletSelectModal.vue?vue&type=style&index=1&id=00c84602&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c84602"]])

export default __exports__